import React, { useState } from "react";
import { CalcRangeSelector } from "../CalcRangeSelector";
import { CalcInput } from "../CalcInput";
import { getHumanPeriodType } from "../../../helpers/helpers";

export const TermSelector = ({ selected, items = [], onSelect }) => {
  const [value, setValue] = useState(selected);
  return (
    <>
      <li className="item item-data">
        <label htmlFor="item-input-loan-term" className="label events-disable">
          Срок
        </label>
        <CalcInput
          id="item-input-loan-term"
          readOnly
          selected={selected}
          tempSelected={value}
          items={items}
          formatValue={(v) => (v ? `${v.number} ${getHumanPeriodType(v)}` : "")}
          onSelect={onSelect}
          className="events-disable"
          isDisabled
        />
      </li>
      <li className="item progressbar">
        <CalcRangeSelector
          selected={selected}
          items={items}
          onChange={setValue}
          onSelect={onSelect}
        />
      </li>
    </>
  );
};
